
export const MARKETING_PAGE_PATH = '/marketing'
export const REGISTER_INTEREST_PAGE_PATH = '/register-interest'

export {
    default as MarketingPage
} from './marketing-page'